export default "__VITE_ASSET__f85497cd__"